import { useUserContext } from "@/contexts/UserContextProvider";
import NotifyBell from "../NotifyBell";
import ChangeLocale from "./ChangeLocale";
import { useNavigate } from "react-router-dom";
import { SUPPORT_ROUTE, USER_PROFILE } from "@/lib/constants/routes";
import Profile from "@/assets/icon/Profile";
import { Button } from "../ui/button";
import { useTranslation } from "react-i18next";

const HeaderCommon = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { uncheckedTickets, user } = useUserContext();

  return (
    <div className="flex justify-end items-center gap-4 mr-[6px]">
      {/* <Input
        type="text"
        placeholder={t("input_search")}
        className="w-full focus-visible:ring-transparent border-2 focus:placeholder:text-[#0064FF] border-gray-300 focus:border-[#0064FF]  max-w-[150px] focus:outline-none rounded-[10px]"
      /> */}
      {user?.impersonation?.is_impersonated &&
        user?.impersonation?.is_admin_session && (
          <Button
            variant="system"
            onClick={() => {
              window.location.href = "/api/user/stop-impersonation/";
            }}
          >
            {t("back_to_admin")}
          </Button>
        )}
      <ChangeLocale />
      <div className="cursor-pointer" onClick={() => navigate(USER_PROFILE)}>
        <Profile />
      </div>
      <div className="cursor-pointer" onClick={() => navigate(SUPPORT_ROUTE)}>
        <NotifyBell notifications={uncheckedTickets.length} />
      </div>
    </div>
  );
};

export default HeaderCommon;
